module.exports = __webpack_public_path__ + "img/devops.dc5054b6.svg";